// src/components/GuidedTour.jsx

import useJoyrideTour from "hooks/useJoyrideTour";
import React, { useEffect } from "react";
import Joyride, { Tooltip } from "react-joyride";
import { useDispatch, useSelector } from "react-redux";
import { stopTour, logTourState, stopAllTour } from "states/guideTour/guideTourSlice";


const CustomTooltip = ({ step, index, size, backProps, closeProps, primaryProps, tooltipProps, onCloseGuide, onClose }) => {
  const {
    hideNext = false,
    hideBack = false,
    hideFinish = false
  } = step || {};
  return (
    <div {...tooltipProps} className="custom-joyride-tooltip tw-px-6 tw-py-6 tw-pt-8 shadow bg-white rounded" style={{
      minWidth: 350, // 👈 ép tối thiểu
      maxWidth: 400,
      // paddingTop: "2.5rem", // 👈 thêm padding phía trên để nút ✕ không đè lên nội dung
      position: "relative",
    }}>
      <button
        {...closeProps}
        className="position-absolute top-0 end-0 m-2 border-0 bg-transparent text-muted"
        aria-label="Close"
        style={{
          fontSize: "1.2rem",
          lineHeight: 1,
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        ✕
      </button>
      <div className="mb-3">{step.content}</div>

      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          {index > 0 && !hideBack && (
            <button
              {...backProps}
              className="tw-border tw-border-gray-400 tw-text-gray-700 tw-px-4 tw-py-2 tw-rounded tw-text-sm hover:tw-bg-gray-100 tw-transition"
            >
              Back
            </button>
          )}

          {index < size - 1 && !hideNext && (
            <button
              {...primaryProps}
              className="tw-bg-primary tw-text-white tw-px-4 tw-py-2 tw-rounded tw-shadow-sm tw-text-sm hover:tw-bg-primary-dark tw-transition"
            >
              Next
            </button>
          )}

          {index === size - 1 && !hideFinish && (
            <button
              {...closeProps}
              className="tw-bg-green-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-shadow-sm tw-text-sm hover:tw-bg-green-700 tw-transition"
            >
              Finish
            </button>
          )}
        </div>
        <button
          onClick={onCloseGuide}
          className="btn btn-sm btn-outline-danger"
        >
          Cancel Guide
        </button>
      </div>
    </div>
  );
};

const GuidedTourV2 = () => {

  const dispatch = useDispatch();
  const { isRun, isRunning, steps } = useSelector((state) => state.guideTour);

  // console.log({ isRun, isRunning, steps })
  return (
    <Joyride
      steps={steps}                      // ✅ Mảng các bước hướng dẫn: mỗi bước có target, content, v.v.
      run={isRun && isRunning}                    // ✅ Tour chạy hay không. Nếu false → không show gì.
      // run={runTour}
      continuous                         // ✅ Khi user click Next → tự động đi bước tiếp theo.
      scrollToFirstStep                  // ✅ Tự động scroll tới phần tử của step đầu tiên nếu nó đang bị khuất.
      disableOverlayClose                // ✅ Không cho người dùng click bên ngoài để tắt hướng dẫn.
      spotlightClicks                    // ✅ Cho phép click vào phần tử bên trong spotlight (ô sáng).
      disableBeacon={true}                      // ✅ ❗ TẮT beacon (nút tròn đỏ nhấp nháy) → nên bật nếu muốn auto run

      tooltipComponent={(props) => (
        <CustomTooltip
          {...props}
          onCloseGuide={() => {
            dispatch(stopAllTour());
          }}
          onClose={() => {
            console.log("onClose")
            dispatch(stopTour());
          }}
        />
      )}  // ✅ Custom UI của popup hướng dẫn
      styles={{
        options: {
          zIndex: 10000,
        },
      }}  // ✅ Đảm bảo hiện lên trên các component khác

      callback={(data) => {
        console.log({ dataJoyride: data })
        // ⛔ Chỉ lưu khi user actively skip hoặc close
        if (["skipped", "finished"].includes(data.status)) {
          // localStorage.setItem("hasSeenGuideTour", "true");
          dispatch(stopTour());
        }
      }}// ✅ Lắng nghe sự kiện: user skip, finish để lưu localStorage, stop tour


    />
  );
}
export default GuidedTourV2;
